module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/privacy-policy/privacy-policy.component.css
// module id = ./src/app/components/privacy-policy/privacy-policy.component.css
// module chunks = main